<template>
  <div class="transit-container">
    <div class="camera-box">
      <video ref="video" autoplay></video>
      <canvas ref="canvas" style="display: none"></canvas>
      <el-input
        v-model="ghxh"
        placeholder="学号/工号"
        style="margin-bottom: 15px"
      ></el-input>
      <el-button-group>
        <el-button type="primary" @click="startCamera" :disabled="isCameraOn">
          开启摄像头
        </el-button>
        <el-button
          type="success"
          :disabled="!isCameraOn"
          @click="handleSign('signin')"
        >
          签到
        </el-button>
        <el-button
          type="warning"
          :disabled="!isCameraOn"
          @click="handleSign('signout')"
        >
          签离
        </el-button>
      </el-button-group>
    </div>

    <!-- 通行记录展示 -->
    <div class="records">
      <h3>最近记录：</h3>
      <el-timeline>
        <el-timeline-item
          v-for="(record, index) in records"
          :key="index"
          :timestamp="formatTime(record.timestamp)"
          placement="top"
        >
          <el-tag :type="record.type === '进入' ? 'success' : 'warning'">
            {{ record.type }}
          </el-tag>
          {{ record.name }} {{ record.userId }} - {{ record.action === "signin" ? "签到" : "签离" }}
        </el-timeline-item>
      </el-timeline>
    </div>
    <div >
      <footers/>
    </div>
  </div>
</template>

<script>
import * as faceapi from "face-api.js";
import footers from '../components/footer.vue'
export default {
  components: {   
    footers
  },
  data() {
    return {
      isCameraOn: false,
      ghxh: "",
      records: [],
      video: null,
      canvas: null,
      modelsLoaded: false,
      detectionsInterval: null,
    };
  },
  async mounted() {
    this.video = this.$refs.video;
    this.canvas = this.$refs.canvas;

    // 加载 face-api.js 模型
    await this.loadModels();
    // 加载最近的通行记录
    this.loadRecords();
  },
  methods: {
    async loadModels() {
      const MODEL_URL = "/models";

      try {
        await Promise.all([
          faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
          faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
          faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
          faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL),
        ]);
        this.modelsLoaded = true;
      } catch (error) {
        this.$message.error("模型加载失败：" + error.message);
      }
    },

    async startCamera() {
      if (!this.modelsLoaded) {
        this.$message.error("模型尚未加载完成");
        return;
      }

      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        this.video.srcObject = stream;
        this.isCameraOn = true;

        this.video.addEventListener("play", () => {
          this.detectionsInterval = setInterval(async () => {
            await this.detectFaces();
          }, 1000);
        });
      } catch (error) {
        this.$message.error("摄像头启动失败：" + error.message);
      }
    },

    async detectFaces() {
      if (!this.video || !this.canvas) return;

      const detections = await faceapi
        .detectAllFaces(this.video, new faceapi.TinyFaceDetectorOptions())
        .withFaceLandmarks()
        .withFaceExpressions();

      if (detections.length > 0) {
        const ctx = this.canvas.getContext("2d");
        ctx.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
        faceapi.draw.drawDetections(this.canvas, detections);
        faceapi.draw.drawFaceLandmarks(this.canvas, detections);
      }
    },

    async handleSign(type) {
      if (!this.modelsLoaded || !this.isCameraOn) {
        this.$message.error("摄像头或模型未准备好");
        return;
      }

      const video = this.$refs.video; // 确保视频元素引用正确
      const detections = await faceapi
        .detectAllFaces(video, new faceapi.TinyFaceDetectorOptions())
        .withFaceLandmarks()
        .withFaceDescriptors();

      if (detections.length === 0) {
        this.$message.error("未检测到人脸");
        return;
      }

      const descriptors = detections.map((d) => d.descriptor);

      try {
        const userResponse = await this.$http.post("/api/get-user-data", {
          ghxh: this.ghxh, // 使用正确的字段名
          
        });

        if (
          !userResponse.success ||
          !userResponse.UserForm ||
          !userResponse.UserForm.faceDescriptors
        ) {
          throw new Error(
            userResponse.message || "用户数据获取失败或缺少必要的属性"
          );
        }

        const userDescriptors = userResponse.UserForm.faceDescriptors.map(
          (d) => new Float32Array(d)
        );

        // 确保 ghxh 是字符串
        const ghxhStr = String(userResponse.UserForm.ghxh);
        const name = userResponse.UserForm.name; // 获取用户名

        const labeledDescriptors = [
          new faceapi.LabeledFaceDescriptors(
            ghxhStr, // 确保 label 是字符串
            userDescriptors
          ),
        ];

        const faceMatcher = new faceapi.FaceMatcher(labeledDescriptors);
        const bestMatch = faceMatcher.findBestMatch(descriptors[0]);

        if (bestMatch.label === ghxhStr) {
          // 使用工号/学号作为标签
          const res = await this.$http.post("/api/transit-record", {
            userId: this.ghxh, // 使用正确的字段
            action: type, // 修正字段名为action
          });

          // 更新本地记录
          this.records.unshift({
            ...res.record,
            type: type === "signin" ? "进入" : "离开",
            timestamp: new Date(),
            name: name, // 添加用户名
          });

          // 限制记录数量为五条
          if (this.records.length > 5) {
            this.records.pop();
          }
          this.$message.success(type === "signin" ? "签到成功" : "签离成功");

          // 清空输入框并关闭摄像头
          this.ghxh = "";
          this.stopCamera();
          // 刷新记录列表
          this.loadRecords();
          // 获取最新的签到率和签离率
        this.fetchTodayRates();
        } else {
          throw new Error("人脸不匹配");
        }
      } catch (error) {
        console.error("操作失败:", error);
        this.$message.error(error.response?.message || error.message);
      }
    },

    stopCamera() {
      if (this.video.srcObject) {
        this.video.srcObject.getTracks().forEach((track) => track.stop());
      }

      clearInterval(this.detectionsInterval);
      this.isCameraOn = false;
    },

    formatTime(timestamp) {
      return new Date(timestamp).toLocaleString("zh-CN", {
        year: "numeric", // 年
        month: "2-digit", // 月
        day: "2-digit", // 日
        hour12: false, // 使用24小时制
        hour: "2-digit", // 小时
        minute: "2-digit", // 分钟
        second: "2-digit", // 秒
      });
    },

    async loadRecords() {
      try {
        const response = await this.$http.get("/api/transit-records");
        if (response && Array.isArray(response)) {
          this.records = response.map(record => ({
            ...record,
            timestamp: record.timestamp ? new Date(record.timestamp) : null, // 格式化时间戳
            type: record.action === "signin" ? "进入" : "离开", // 确保 type 字段正确
          })).slice(0, 5); // 只保留最新的五条记录
        } else {
          console.warn("Invalid data format received from server");
          this.$message.warning("服务器返回的数据格式不正确");
        }
      } catch (error) {
        console.error("加载记录失败:", error);
        this.$message.error("加载记录失败，请稍后再试");
      }
    },
    beforeDestroy() {
      this.stopCamera();
    },
  },
};
</script>

<style scoped>
.transit-container {
  display: flex;
  width: 100%;
  height: 90%; /* 使用视口高度单位 */
}

.camera-box, .records {
  flex: 1; /* 平分可用空间 */
  padding: 1rem;
}

.camera-box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

video {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transform: scaleX(-1); /* 镜像显示 */
}

canvas {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}

.records {
  font-size: 0.9rem;
  border-left: 1px solid #ddd;
}

@media (max-width: 768px) {
  .transit-container {
    flex-direction: column;
    height: auto;
  }

  .camera-box, .records {
    height: auto;
    max-height: none;
  }
}
</style>
